<div class="tree-picker-cell-editor">
  <lib-cdw-filtered-tree-picker
    [formControl]="selectedControl"
    [dataSource]="dataSource"
    [height]="height"
    [filterPlaceholder]="filterPlaceholder"
    [filterLabel]="filterLabel"
    [multiSelect]="false"
    [scrollToValue]="initialValue"
  ></lib-cdw-filtered-tree-picker>
</div>
